<script setup>
/* eslint-disable */
// Components
import { getAllPages } from "@/utils/getAllPages";
import SharedDeleteConfirmDialog from "@/components/shared/SharedDeleteConfirmDialog.vue";
import HeaderTitle from "@/components/layout/HeaderTitle.vue";

// Services
import ResourceService from '@/api/services/resource.service';
import Notification from '@/utils/plugins/NotificationService';
import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useUiStore } from "@/app/stores/uiStore";
import { useVuelidate } from "@vuelidate/core";
import { helpers, minLength, required, } from '@vuelidate/validators'
import message from "@const/message";

const searchFilterJobName = ref('')
const searchFilterDepartment = ref(null)
let searchTimer;
let jobsRequestId = 0;
const createOrUpdateJobDialog = ref(false)
const isUpdateJob = ref(false)
const jobs = ref([]);
const job = ref({});
const department = ref({});
const productiveArray = ref([
  { 'name': 'Productivo', 'productive': true },
  { 'name': 'No productivo', 'productive': false }
]);
const productive = ref({});
const departments = ref([]);
const deleteDialogShown = ref(false);
const selectedJob = ref([]);
const jobName = ref('');

const rules = computed(() => {
  return {
    jobName: {
      required: helpers.withMessage(message.required, required),
      minLength: helpers.withMessage("La longitud mínima del campo es de 3", minLength(3))
    }
  }
})
const $v = useVuelidate(rules, { jobName });

const uiStore = useUiStore();
onMounted(() => {
  getJobs();
  getDepartments();
})

onUnmounted(() => {
  clearTimeout(searchTimer);
  jobsRequestId++;
});

watch(searchFilterJobName, () => {
  clearTimeout(searchTimer);
  jobsRequestId++;
  searchTimer = setTimeout(() => getJobs(), 300);
});

const visibleJobs = computed(() => {
  const collator = new Intl.Collator('es', { sensitivity: 'base', numeric: true });
  return jobs.value
    .filter((item) => searchFilterDepartment.value == null || searchFilterDepartment.value === ''
      || item.department?.id === searchFilterDepartment.value)
    .sort((a, b) => collator.compare(a.department?.name || '', b.department?.name || '')
      || collator.compare(a.name || '', b.name || ''));
});

const notEmptyObject = (someObject) => {
  return Object.keys(someObject).length;
}
const editJob = (job) => {
  selectedJob.value = job;
  jobName.value = job.name;
  productive.value = {
    productive: job.productive,
    name: job.productive ? 'Productivo' : 'No productivo'
  };
  department.value = (job.department && notEmptyObject(job.department)) ? job.department : {};
  isUpdateJob.value = true
  createOrUpdateJobDialog.value = true
}
const getJobs = async (searchQuery = searchFilterJobName.value) => {
  const params = searchQuery ? { name: searchQuery } : {};
  const requestId = ++jobsRequestId;
  uiStore.startLoading();
  try {
    const result = await getAllPages(ResourceService.getJobs, params);
    if (requestId === jobsRequestId) jobs.value = result;
  } finally {
    uiStore.stopLoading();
  }
}

const getDepartments = async () => {
  uiStore.startLoading();
  try {
    departments.value = await getAllPages(ResourceService.getDepartments);
  } finally {
    uiStore.stopLoading();
  }
}
const deleteJob = (job) => {
  ResourceService.deleteJob(job.id)
    .then(() => {
      Notification.addNotification('Tipo de trabajo eliminado correctamente.', 'success', 6000);
      deleteDialogShown.value = false;
      cancel();
    }).catch(() => {
      Notification.addNotification('Error al eliminar el tipo de trabajo seleccionado', 'error', 6000);
      // uiStore.setLoading(false);
      uiStore.stopLoading();
    })
}
const createJob = (job) => {
  job.name = jobName.value;
  job.productive = productive.value.productive;
  if (notEmptyObject(department.value)) {
    job.department = department.value['@id'];
  }
  // uiStore.setLoading(true);
  uiStore.startLoading();
  ResourceService.createJob(job)
    .then(() => {
      Notification.addNotification('Tipo de trabajo creado correctamente', 'success', 6000);
      // uiStore.setLoading(false);
      uiStore.stopLoading();
      getJobs();
    })
    .catch(() => {
      Notification.addNotification('Error al crear el tipo de trabajo', 'error', 6000);
      // uiStore.setLoading(false);
      uiStore.stopLoading();
    })
    .finally(() => {
      closeCreateOrUpdateDialog()
    })

}
// eslint-disable-next-line no-unused-vars
const updateJob = async (job) => {
  if (jobName.value) {
    job.name = jobName.value;
  }

  job.productive = productive.value.productive;

  if (notEmptyObject(department.value)) {
    job.department = department.value['@id'];
  }

  // uiStore.setLoading(true);
  uiStore.startLoading();
  await ResourceService.updateJob(job, selectedJob.value.id)
    .then(() => {
      Notification.addNotification('Tipo de trabajo actualizado correctamente', 'success', 6000);
      // uiStore.setLoading(false);
      uiStore.stopLoading();
      getJobs();
    })
    .catch(() => {
      Notification.addNotification('Error al actualizar el tipo de trabajo', 'error', 6000);
      // uiStore.setLoading(false);
      uiStore.stopLoading();
    })
    .finally(() => {
      closeCreateOrUpdateDialog()
    })
}

const reset = () => {
  job.value = {};
  jobName.value = '';
  selectedJob.value = null;
  department.value = {};
  productive.value = {};
  isUpdateJob.value = false
}
const cancel = () => {
  reset()
  getJobs();
}

const closeCreateOrUpdateDialog = () => {
  createOrUpdateJobDialog.value = false
  reset()
}



// eslint-disable-next-line no-unused-vars
const isProductive = (isProductive) => {
  return isProductive ? 'Si' : 'No';
}


</script>

<template>
  <div>
    <!--        <h1>Puestos de Trabajo</h1>-->
    <HeaderTitle title="Ajustes" />
    <div class="d-flex flex-row justify-content-start">
      <img src="@/assets/icons/group.svg" width="30" alt="">
      <div class="title-text pl-4">
        Puestos de Trabajo
      </div>
    </div>
    <el-card class="card-search w-100 wback" body-style="padding:0">
      <div class="row mx-5 master-search-row">
        <div class="container-jobs">
          <div class="row align-items-end">
            <div class="col-md-4 col-12">
              <div>
                <div class=" form-item  date-picker  label-common">
                  <label class=" w-100 mb-2">Nombre</label>
                  <el-input v-model="searchFilterJobName" placeholder="Nombre del Puesto de trabajo"
                    prefix-icon="el-icon-search" clearable />
                </div>
              </div>
            </div>
            <div class="col-md-4 col-12">
              <div class="form-item date-picker label-common">
                <label class="w-100 mb-2">Departamento</label>
                <el-select v-model="searchFilterDepartment" class="w-100" placeholder="Departamento" filterable clearable>
                  <el-option v-for="item in departments" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
              </div>
            </div>
            <div class="col-md-4 col-12 d-flex justify-content-end master-search-actions">
              <button @click="createOrUpdateJobDialog = true" class="btn btn_darkpink btn-search master-create-button">
                NUEVO PUESTO DE TRABAJO
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-card>
    <div class="table table-not-mobile">
      <div v-if="visibleJobs.length > 0">
        <table>
          <thead>
            <tr>
              <th>Departamento</th>
              <th>Nombre</th>
              <th>Productivo</th>
              <th class="master-actions-col">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="job in visibleJobs" :key="job.id" class="pointer" @click="editJob(job)">
              <td>{{ job.department?.name || '--' }}</td>
              <td>{{ job.name }}</td>
              <td>{{ isProductive(job.productive) }}</td>
              <td class="master-actions-col">
                <div class="buttons d-inline-flex">
                  <font-awesome-layers class="fa-2x pointer" style="margin-left: 5px" title="Editar"
                    @click.stop="editJob(job)">
                    <font-awesome-icon icon="circle" style="color: #f7d20e" />
                    <font-awesome-icon icon="plus" class="fa-inverse" transform="shrink-6" />
                  </font-awesome-layers>
                  <font-awesome-layers class="fa-2x pointer" style="margin-left: 5px" title="Eliminar"
                    @click.stop="deleteDialogShown = true; selectedJob = job;">
                    <font-awesome-icon icon="circle" style="color:red" />
                    <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
                  </font-awesome-layers>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-else>
        <h5>No se han encontrado tipos de puestos de trabajo</h5>
      </div>
    </div>

    <div class="table-mobile">
      <div v-if="visibleJobs.length > 0">
        <el-row v-for="job in visibleJobs" :key="job.id" class="mt-3">
          <el-card class="master-mobile-card w-100 pointer" @click="editJob(job)">
            <div class="master-mobile-card__delete">
              <font-awesome-layers class="fa-2x pointer" title="Eliminar" @click.stop="deleteDialogShown = true; selectedJob = job;">
                <font-awesome-icon icon="circle" style="color:red" />
                <font-awesome-icon icon="times" class="fa-inverse" transform="shrink-6" />
              </font-awesome-layers>
            </div>
            <div class="master-mobile-card__title">{{ job.name }}</div>
            <div class="master-mobile-card__item">
              <span><b class="master-mobile-card__label">Productivo:</b> {{ isProductive(job.productive) }}</span>
            </div>
            <div class="master-mobile-card__item">
              <span><b class="master-mobile-card__label">Departamento:</b> {{ job.department && job.department.name ? job.department.name : '--' }}</span>
            </div>
          </el-card>
        </el-row>
      </div>
      <div v-else class="mt-3">
        <h5>No se han encontrado tipos de puestos de trabajo</h5>
      </div>
    </div>

    <el-dialog class="el-dialog job-dialog" v-model="createOrUpdateJobDialog" @closed="closeCreateOrUpdateDialog()"
      :show-close="false" size="'medium'" width="850" :center="true" :lock-scroll="true"
      :style="{ borderRadius: `var(--el-border-radius-round)` }">
      <div class="my-header">
        <svg id="asterisk" xmlns="http://www.w3.org/2000/svg" width="724" height="1024" viewBox="0 0 724 1024">
          <path
            d="M0 499.8l59-181.7 332.5 108.6-59 180.8-332.5-107.7zM79.6 744.3l206.1-282.9 154.5 111.5-206.1 283.8-154.5-112.4zM266.9 167.3h191.1v350.3h-191.1v-350.3zM285.6 572.9l154.5-111.5 206.1 282.9-154.5 112.4-206.1-283.8zM332.5 426.8l332.5-108.6 59 181.7-331.6 107.7-59.9-180.8z" />
        </svg>
        <span class="text-header ml-5 mt-3">{{ isUpdateJob ? 'Actualizar ' : 'Nuevo ' }}Puesto de trabajo</span>
        <img class="close-icon pointer" src="@/assets/images/aspa_blue_small_entrada.png" alt=""
          @click="closeCreateOrUpdateDialog()">
      </div>
      <div class="my-body">
        <form @submit.prevent="">
          <div class="row">
            <div class="col-12">
              <div class="form-item">
                <label class="w-100">Puesto de trabajo</label>
                <el-form-item prop="username" :error="$v.jobName.$errors[0]?.$message">
                  <el-input v-model="$v.jobName.$model" class="w-100" placeholder="Nombre del Puesto de trabajo"
                    prefix-icon="el-icon-search" clearable />
                </el-form-item>

              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-item">
                <label class="w-100">Productividad</label>
                <el-select v-model="productive" class="w-100" placeholder="Productividad" filterable clearable value-key="name">
                  <el-option v-for="item in productiveArray" :key="item.name" :label="item.name" :value="item" />
                </el-select>
              </div>
            </div>
            <div class="col-md-6 col-12">
              <div class="form-item">
                <label class="w-100">Departamento</label>
                <el-select v-model="department" class="w-100" placeholder="Departamento" filterable clearable value-key="@id">
                  <el-option v-for="item in departments" :key="item.id" :label="item.name" :value="item" />
                </el-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4 offset-md-8 col-12 d-flex flex-column justify-content-center align-items-center master-dialog-actions">
              <button class="btn btn_darkpink" :disabled="$v.$invalid"
                @click="isUpdateJob ? updateJob(job) : createJob(job)">
                {{ isUpdateJob ? 'Actualizar' : 'Nuevo' }}
              </button>
            </div>
          </div>


          <!--                    <div class="col-md-3 text-right"  v-if="user && ifIsInArray('ROLE_SUPER_ADMIN', user.rol) && title.length > 0">-->
        </form>
      </div>
    </el-dialog>

    <SharedDeleteConfirmDialog v-model="deleteDialogShown" title="Eliminar tipo de trabajo"
      message="¿Desea eliminar permanentemente este tipo de trabajo?" @confirm="deleteJob(selectedJob)"
      @cancel="selectedJob = null" />
  </div>
</template>

<style lang="scss" scoped>
.card-search {
  height: 200px;
}

.master-search-row .form-item {
  margin-bottom: 0;
}

.master-create-button {
  width: 100%;
  max-width: 300px;
  min-height: 44px;
  margin-bottom: 0 !important;
  color: white;
}

.my-body.my-body {
  margin-right: 0;
}

.table-mobile {
  display: none;
}

.master-mobile-card {
  border-radius: 16px;
}

.master-mobile-card :deep(.el-card__body) {
  position: relative;
  padding: 16px 18px;
}

.master-mobile-card__delete {
  position: absolute;
  top: 10px;
  right: 12px;
  z-index: 1;
}

.master-mobile-card__title {
  color: $bg-blue;
  font-size: 18px;
  font-weight: 800;
  line-height: 1.25;
  margin-bottom: 10px;
  padding-right: 42px;
  word-break: break-word;
}

.master-mobile-card__item {
  margin-bottom: 10px;
  word-break: break-word;
}

.master-mobile-card__label {
  color: $bg-blue;
  font-weight: 800;
}

.master-mobile-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
}

.master-actions-col {
  width: 110px;
  min-width: 110px;
  text-align: center;
}

.job-input {
  /*display: flex;*/
  vertical-align: baseline;
  margin: 30px 10px 10px 10px;
}

.table-jobs {
  padding: 40px;

  table {
    border-collapse: separate;
    border-spacing: 0 25px;
    color: #858796;
    // text-align-all: left;
    text-align: left;
    width: 100%;

    th {
      //border: 1px solid #e3e6f0;
      color: $font-blue-color;
      padding: 12px 12px 12px 20px;
      font-size: 20px;
      text-align: center;
    }

    tbody {
      //tr:nth-child(odd) {
      //  td {
      //    background-color: rgba(0, 0, 0, .05);
      //  }
      //}

      td {

        background-color: white;
        border: 1px solid #e3e6f0;
        padding: 12px 12px 12px 20px;
        text-align: left;

        a {
          font-size: 18px;
          color: #4e73df;
        }
      }

      tr:nth-child(n) {
        td:first-child {
          border-top-left-radius: 10px;
          border-bottom-left-radius: 10px;
          -moz-border-radius-topleft: 10px;
          -moz-border-radius-bottomleft: 10px;
          -webkit-border-top-left-radius: 10px;
          -webkit-border-bottom-left-radius: 10px;

          -webkit-box-shadow: 0 .5rem 1rem rgba(58, 59, 69, .15);
          -moz-box-shadow: 0 .5rem 1rem rgba(58, 59, 69, .15);
          box-shadow: 0 .5rem 1rem rgba(58, 59, 69, .15);
        }

        td:last-child {
          border-top-right-radius: 10px;
          border-bottom-right-radius: 10px;
          -moz-border-radius-topright: 10px;
          -moz-border-radius-bottomright: 10px;
          -webkit-border-top-right-radius: 10px;
          -webkit-border-bottom-right-radius: 10px;

          -webkit-box-shadow: 0 0.5rem 1rem rgba(58, 59, 69, .15);
          -moz-box-shadow: 0 0.5rem 1rem rgba(58, 59, 69, .15);
          box-shadow: 0 0.5rem 1rem rgba(58, 59, 69, .15);
        }

        td:nth-child(n) {
          -webkit-box-shadow: 0 0.5rem 1rem rgba(58, 59, 69, .15);
          -moz-box-shadow: 0 0.5rem 1rem rgba(58, 59, 69, .15);
          box-shadow: 0 0.5rem 1rem rgba(58, 59, 69, .15);
        }
      }
    }
  }
}

.el-dialog {
  background: #f3f0fb !important;
}

.el-dialog__body {
  background: #f3f0fb !important;
  min-height: 800px !important;

  .el-dialog__header {
    padding: 0;
  }

  .my-header {
    margin-top: 2px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .text-header {
      text-align: left;
      font-size: 4em;
      font-weight: 900;
      letter-spacing: -0.05em;
      color: #f9156f;
    }

    .close-icon {
      width: 8%;
      height: 20%;
    }

    .inter-icon {
      width: 2%;
      height: 2%;
    }

    #asterisk {
      position: absolute;
      vertical-align: super;
      height: auto;
      width: 2.2em;
      fill: #f9156f;
    }

  }

}

@media (min-width: 768px) {
  .table-mobile {
    display: none;
  }
}

@media (max-width: 767px) {
  .title-text {
    font-size: 2.2em;
  }

  .card-search {
    height: auto;
    padding: 20px 16px;
    background-size: 92px;
    background-position: calc(100% + 16px) 12px;
  }

  .master-search-row {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .master-search-actions {
    margin-top: 10px;
  }

  .master-search-actions .btn-search {
    width: 100%;
    max-width: 100% !important;
    min-width: 100% !important;
  }

  .table-not-mobile {
    display: none;
  }

  .table-mobile {
    display: block;
    padding-right: 14px;
  }

  :deep(.job-dialog) {
    width: calc(100vw - 24px) !important;
    max-width: calc(100vw - 24px);
    margin-top: 4vh !important;
  }

  :deep(.job-dialog .el-dialog__body) {
    min-height: auto !important;
  }

  .el-dialog__body .my-header {
    align-items: flex-start;
    gap: 12px;
    padding-right: 10px;
  }

  .el-dialog__body .my-header .text-header {
    font-size: 2em;
    line-height: 1.1;
    margin-top: 0.75rem !important;
  }

  .el-dialog__body .my-header .close-icon {
    width: 26px;
    min-width: 26px;
    margin-top: 12px;
  }

  .master-dialog-actions {
    align-items: stretch !important;
    margin-left: 0 !important;
  }

  .master-dialog-actions .btn {
    width: 100%;
  }
}
</style>
